// Module
var code = " <label class=\"field field_v3\"> <input class=\"field__input\" placeholder=\"Escribe algo...\"/> <span class=\"field__label-wrap\"> <span class=\"field__label\">Objeto</span> </span> </label> ";
// Exports
module.exports = code;